import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBowlFull = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 102,
	height: 83,
	viewBox: "0 0 102 83",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M32.7874 76.3378C32.8934 72.1353 36.3862 68.8144 40.5887 68.9204L47.6013 69.0973C51.8038 69.2033 55.1247 72.696 55.0187 76.8985C54.9738 78.6806 54.2106 80.3611 52.5096 80.8946C50.826 81.4227 48.0899 81.8963 43.7727 81.7875C39.4555 81.6786 36.7468 81.0676 35.0919 80.4553C33.42 79.8367 32.7425 78.1199 32.7874 76.3378Z",
			fill: "#4EA4BD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M33.0347 66.8032L55.2659 67.3639L55.0081 77.5894C55.0081 77.5894 52.9358 79.9167 43.8324 79.6871C34.7291 79.4575 32.7768 77.0287 32.7768 77.0287L33.0347 66.8032Z",
			fill: "#002938"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.7582 38.8758L95.9781 37.8683L93.7712 43.3617C85.7973 63.2099 67.0272 76.6247 45.6663 77.7416L41.4654 77.665C21.6778 77.3042 8.38052 57.2402 15.7582 38.8758Z",
			fill: "#4EA4BD"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 55.766,
			cy: 38.3878,
			rx: 40.1866,
			ry: 5.60336,
			transform: "rotate(-0.719593 55.766 38.3878)",
			fill: "#06748D"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 60.9893,
			cy: 62.1606,
			rx: 16.5546,
			ry: 7.44958,
			transform: "rotate(-26.6498 60.9893 62.1606)",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 49.8268,
			cy: 58.5835,
			rx: 6.42917,
			ry: 2.89312,
			transform: "rotate(-34.4609 49.8268 58.5835)",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_4451_534",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 13,
			y: 0,
			width: 89,
			height: 44,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M101.028 37.8191L98.9274 37.8455L98.9155 37.9902C98.405 41.0248 80.6603 43.6789 58.8134 43.9533C36.6209 44.232 18.5985 41.9493 18.5597 38.8549L14.0073 38.9121L13.5323 1.09277L100.553 -0.00019782L101.028 37.8191Z",
				fill: "#D9D9D9"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0_4451_534)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M29.4668 51.3466L29.2315 32.6118L38.5715 51.2322L29.4668 51.3466Z",
					fill: "#002938"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M21.7964 16.9084C20.7278 14.2164 22.224 11.1912 25.012 10.4065C27.8 9.62183 30.6544 11.4225 31.1469 14.2767L37.2636 49.7271L35.0683 50.345L21.7964 16.9084Z",
					fill: "#06748D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M68.8844 29.1961C81.0362 23.0977 93.1117 22.5866 95.8565 28.0546C98.6009 33.523 90.9745 42.9001 78.8223 48.9987C66.6705 55.0971 54.5949 55.6083 51.8501 50.1402C51.501 49.4445 51.3198 48.685 51.2943 47.8775C46.1523 51.3669 41.1891 52.4671 38.9771 50.2199C36.0608 47.2571 39.0335 39.6013 45.6174 33.1205C52.201 26.64 59.9024 23.7885 62.819 26.7506C63.9904 27.9406 64.2101 29.8876 63.6288 32.2116C65.2601 31.1467 67.0186 30.1324 68.8844 29.1961Z",
					fill: "white"
				})
			]
		})
	]
});
const ForwardRef = forwardRef(SvgBowlFull);
export default ForwardRef;
